// Splide init
function mmInitSplide() {
  const id = '.mm-splide-crossell-page';
  const splideElem = document.querySelector(id);
  const idrea = '.splide-cta-testimonials-page';
  const splideElemrea = document.querySelector(idrea);

  if (splideElem) {
    new Splide(splideElem, {
      type   : 'splide',
      arrows: false,
      pagination: false,
      rewind: true,
      gap: 8,
      perPage: 2
      }).mount();
  }

  if (splideElemrea) {
    new Splide( splideElemrea, {
        type   : 'loop',
        arrows: false,
        pagination: true,
        gap: 0,
        perPage: 1,
        autoplay: true,
        interval: 3000
    }).mount();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  mmInitSplide();
}, { once: true });

// Debounce
function debounce(func, duration) {
  let timeout;
  return function (...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  }
}

// IMPORTANT: the cart lives in a JSON template, so its wrapper id is
// "shopify-section-template--<hash>__cart-items". Match by suffix so the
// changing template hash can never break this lookup again.
function mmCartSectionElement() {
  return document.querySelector('[id^="shopify-section"][id$="cart-items"]');
}

function mmCartProductsContainerElement() {
  return mmCartSectionElement()?.querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement()
           ?.querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
  const itemEl = mmCartItem(productVariantId);
  return itemEl ? itemEl.querySelector("[data-item-quantity]") : null;
}

function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);
  if (!quantityEl) return 0;
  return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    if (!quantityEl) return;
    quantityEl.dataset.itemQuantity = newQuantity;
    quantityEl.innerText = newQuantity;
  }
}

function mmAPIRequest(method, path, body) {
  document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
  return fetch(window.Shopify.routes.root + path, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(response => response.json())
    .then((data) =>  {
      document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
      if (data.status && data.status > 400) {
        throw(data);
      } else {
        return data;
      }
    });
}

// Fetch the freshly rendered /cart page HTML.
// We render from the full page rather than the Cart Sections API, because the
// section id passed to that API was wrong and returned a 500. GET /cart always
// renders correctly server-side, so this is reliable.
function mmFetchCartPage() {
  return fetch(window.Shopify.routes.root + 'cart').then((r) => r.text());
}

// Re-render the cart from a full /cart page HTML string.
// Returns the parsed page wrapper (for downstream free-product logic), or null.
function refreshCartFromPage(pageHtml) {
  const newCartEl = document.createElement('DIV');
  newCartEl.innerHTML = pageHtml;
  const source = newCartEl.querySelector('.mm-drawer-cart-filter-page');
  const innerCart = mmCartSectionElement()?.querySelector('.mm-drawer-cart-filter-page');
  if (!source || !innerCart) return null; // never blank the cart if structure is missing
  innerCart.innerHTML = source.innerHTML;
  mmInitSplide();
  return newCartEl;
}

// récupérer le panier
function mmGetCart() {
  return mmAPIRequest('GET', 'cart.js');
}

// Ouvrir le panier
function mmOpenCart() {
  mmGetCart();
  document.querySelector('.mm-drawer-cart-filter-page')?.classList.add('mm-dc-is-open');
  document.querySelector('html').classList.add('stop-scrolling');
}

// Ouvrir et refresh le panier (babybox/superbox)
function mmOpenAndRefreshCart() {
  mmFetchCartPage().then((pageHtml) => {
    refreshCartFromPage(pageHtml);
    document.querySelector('.mm-drawer-cart-filter-page')?.classList.add('mm-dc-is-open');
    document.querySelector('html').classList.add('stop-scrolling');
  });
}

// Fermer le panier
function mmCloseCart() {
  document.querySelector('.mm-drawer-cart-filter-page')?.classList.remove('mm-dc-is-open');
  document.querySelector('html').classList.remove('stop-scrolling');
}

// Reconcile free products from the parsed /cart page wrapper.
function mmReconcileFreeProducts(pageEl) {
  if (!pageEl) return;
  const freeProductEls = pageEl.querySelector("[data-free-products]");
  const cartTotalEl = pageEl.querySelector('.mm-drawer-cart-page');
  if (!freeProductEls || !cartTotalEl) return;
  const cartTotal = cartTotalEl.dataset.cartTotal;

  const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
    const productId = freeProductEl.dataset.variantId;
    const isFree = freeProductEl.dataset.freeProduct == "true";
    const itemEl = mmCartItem(productId);
    var freeProductName = 'free_product_cancelled_' + productId;
    var doNotAdd = freeProductEl.dataset.doNotAdd;

    if ((freeProductEl.dataset.freeProductAmount * 100) > cartTotal) {
      localStorage.setItem(freeProductName, "false");
    }

    if (itemEl && isFree) {
      // already added, do nothing
    } else if (itemEl && !isFree) {
      param[productId] = 0; // present but should be removed
    } else if (!itemEl && isFree) {
      if (doNotAdd == "false") {
        if (!localStorage.getItem(freeProductName)) {
          localStorage.setItem(freeProductName, "false");
        }
        if (localStorage.getItem(freeProductName) == 'false') {
          param[productId] = 1; // absent but should be added
        }
      }
    }
    return param;
  }, {});

  if (Object.keys(productsParams).length > 0) {
    mmAPIRequest("POST", "cart/update.js", { updates: productsParams })
      .then(mmFetchCartPage)
      .then(refreshCartFromPage);
  }
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {

  if (document.getElementById('mmChoixDesSavons')) {
    var LIproperty = document.getElementById('mmChoixDesSavons').value
  }

  mmAPIRequest('POST', 'cart/add.js', {
    items: [
      {
        quantity: quantity,
        id: productId,
        properties: {
          'Savons': LIproperty
        }
      }
    ]
  })
    .then(mmFetchCartPage)
    .then((pageHtml) => {
      const pageEl = refreshCartFromPage(pageHtml);
      mmReconcileFreeProducts(pageEl);
      if (openCart) {
        setTimeout(mmOpenCart);
      }
    }).catch((error) => {
      const c = mmCartProductsContainerElement();
      if (c) c.innerHTML = `Oups, il y a eu une erreur, essayez de recharger la page !`;
      mmOpenCart();
      console.log(error);
    })
}

// Ajouter un item au panier avec des properties
function mmAddProductToCartWithproperties(productId, { quantity = 1, openCart = true }, produitsRoutine) {

  if (document.getElementById('mmChoixDesSavons')) {
    var LIproperty = document.getElementById('mmChoixDesSavons').value
  }

  var variantSelected = document.querySelector('.mm-product-variant-checkbox:checked');
  if(variantSelected) {
    if(produitsRoutine === undefined) {} else {
      var produitsRoutine = produitsRoutine + ' | ' + variantSelected.name.replace('options[','').replace(']','').toUpperCase() + ": " + variantSelected.value.toUpperCase();
    }
  }
  mmAPIRequest('POST', 'cart/add.js', {
    items: [
      {
        quantity: quantity,
        id: productId,
        properties: {
          'Savons': LIproperty,
          'Produits': produitsRoutine
        }
      }
    ]
  })
    .then(mmFetchCartPage)
    .then((pageHtml) => {
      const pageEl = refreshCartFromPage(pageHtml);
      mmReconcileFreeProducts(pageEl);
      if (openCart) {
        setTimeout(mmOpenCart);
      }
    }).catch((error) => {
      const c = mmCartProductsContainerElement();
      if (c) c.innerHTML = `Oups, il y a eu une erreur, essayez de recharger la page !`;
      mmOpenCart();
      console.log(error);
    })
}

function mmIncreaseProductQuantity(productVariantId) {
   const quantity = mmGetCartItemQuantity(productVariantId);
   const newQuantity = quantity + 1;
   mmSetCartItemQuantity(productVariantId, newQuantity);
   mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);
  const newQuantity = quantity - 1;
  mmSetCartItemQuantity(productVariantId, newQuantity);
  mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
  const newQuantity = 0;
  mmSetCartItemQuantity(productVariantId, newQuantity);
  mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);

  mmAPIRequest('POST', 'cart/change.js', {
    id: productVariantId.toString(),
    quantity: quantity
  })
    .then(mmFetchCartPage)
    .then((pageHtml) => {
      const pageEl = refreshCartFromPage(pageHtml);
      if (!pageEl) { window.location.href = '/cart'; return; }
      mmReconcileFreeProducts(pageEl);
    })
    .catch((error) => {
      console.error('mmPushNewQuantity failed', error);
      window.location.href = '/cart';
    });
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
  clickedElem.innerText = "AJOUTÉ !";
  clickedElem.classList.add('mm-disabled');

  mmAPIRequest('POST', 'cart/add.js', {
    items: [{ quantity: 1, id: productVariantIdToAdd }]
  }).then(() => mmDestroyProductFromCart(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function(productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);

function mmDestroyFreeProductForEver(freeProductId) {
  var freeProductName = 'free_product_cancelled_' + freeProductId;
  localStorage.setItem(freeProductName, "true");
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");
    mmAddProductToCart(productId, { openCart: false });
}

window.addEventListener("DOMContentLoaded", (event) => {
    mmGetCart();
});